import { RoleObjectType } from '@/interfaces/roleObjectType';
import { RoleResource, roleResource } from '@/resources/role.resource';
import store from '@/store/store';
import { EntityModule } from './entity.module';
import permission from './roles/permissionRelation.module';

/**
 * Moduł ról
 *
 * @export
 * @class RoleModule
 * @extends {EntityModule<RoleObjectType, RoleResource>}
 */
export class RoleModule extends EntityModule<RoleObjectType, RoleResource> {
  public modules = { permission };

  constructor() {
    super(roleResource);
    this.actions = {
      ...this.actions,
      /**
       * Dodaje encję
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      add: async (context: any, data: any): Promise<void> => {
        await this.resource.add(data);
        store.dispatch('role/list', { count: -1 });
      },
      /**
       * Aktualizuje encję
       *
       * @param context context
       * @param data dane encji
       */
      update: async (context: any, data: any): Promise<void> => {
        await this.resource.update(data.id as number, data);
        store.dispatch('role/list', { count: -1 });
      },
      /**
       * Usuwa encję
       *
       * @param context context
       * @param id identyfikator encji
       */
      remove: async (context: any, id: number): Promise<void> => {
        await this.resource.delete(id);
        store.dispatch('role/list', { count: -1 });
      }
    };
  }
}

export default new RoleModule();
